<template>
    <div :class="{'z-20': active}">
        <div
            class="relative flex items-center justify-center w-[36px] h-[36px] rounded-full bg-white/25 border border-white map-point-circle cursor-pointer"
            :class="active ? 'pointer-events-none' : 'pointer-events-auto'"
        >
            <span class="w-5 h-5 bg-white rounded-full map-point"></span>
            <span class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-5 h-5 bg-white rounded-full"></span>
        </div>
        <transition name="popover">
            <div
                v-if="active"
                class="popover flex flex-col w-[209px] p-[20px] absolute top-1/2 text-white transform -translate-y-1/2 rounded-[15px] text-left pointer-events-auto"
                :class="[direction === 'left' ? 'right-16' : 'left-16', `bg-[${colors[type]}]`]"
                @mouseleave="$emit('close', $event)"
            >
                <h3 v-if="item.title" class="font-normal text-[20px] leading-none">{{ item.title }}</h3>
                <p v-if="item.subtitle" class="text-[10px] font-light">{{ item.subtitle }}</p>
                <img v-if="item.image" class="block w-full mt-[11px]" :src="item?.image" :alt="title" />
                <div v-if="item.tags.length" class="flex mt-3.5 items-center justify-between">
                    <div class="flex">
                        <div v-for="(tag, index) in item.tags" :key="index" class="uppercase text-white text-[10px] font-light">
                            {{ tag.name }}<span v-if="index + 1 < item.tags.length">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                        </div>
                    </div>
                    <a v-if="item.link && item.show_link" class="text-white text-[10px] text-center border border-white px-[10px] pt-[2px] pb-[1px] rounded-[14px] ml-2.5 hover:bg-white hover:text-black" :title="item.link_label" :href="item?.link" target="_blank" rel="noopener noreferrer">
                        {{ item.link_label }}
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'right'
        },
        type: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            colors: {
                living: '#B9562A',
                hotel: '#EFA736',
                office: '#1A3450',
                park: '#193E2F'
            }
        }
    }
}
</script>